import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const ClaimLogin = async (credentials) => {
  const config = {
    headers: { "Content-Type": "application/json" },
  };
  const response = await axios.post(
    `${BACKEND_URL}api/auths/login`,
    credentials,
    config
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ClaimLogin,
};